import { useContext, useEffect } from 'react'
import { useStore } from 'zustand'

import type { Analysis, AnalysisStore } from '@/modules/analysis'
import { useAsyncError } from '@/modules/errors'
import { ProjectContext } from '@/modules/projects/components/ProjectStoreContext'
import { useFetchCaseConfig } from '@/modules/projects/hooks/caseConfig'

const useAnalysisStore = <T>(selector: (state: AnalysisStore) => T): T => {
  const stores = useContext(ProjectContext)
  const store = stores?.projectAnalysisStore

  if (!store) {
    throw new Error('useAnalysisStore must be used within ProjectProvider')
  }

  return useStore(store, selector)
}

export const useAnalysis = () =>
  useAnalysisStore((state) => state.analysis as Analysis)

export const useLoadingAnalysis = () =>
  useAnalysisStore((state) => state.loadingAnalysis)

export const useAnalysisActions = () =>
  useAnalysisStore((state) => state.actions)

export const useAnalysisMutations = () =>
  useAnalysisStore((state) => state.mutations)

export const useAnalysisMutating = () =>
  useAnalysisStore((state) => state.mutating)

export const useAnalysisLoaders = () =>
  useAnalysisStore((state) => state.loaders)

export const useFetchAnalysis = (slug: string) => {
  const { fetchAnalysis } = useAnalysisLoaders()
  const throwError = useAsyncError()

  useFetchCaseConfig()

  useEffect(() => {
    fetchAnalysis(slug).catch(throwError)
  }, [])
}
